<div
  #container
  tabindex="-1"
  aria-labelledby="search-label"
  role="menu"
  id="program-switcher-menu"
  [class.mobile]="isMobile"
>
  @if (isMobile) {
  <div class="mobile-header">
    <button
      neo-button
      size="sm"
      color="gray"
      [wrap]="false"
      [iconOnly]="false"
      aut-id="program-switcher-back-button"
      (click)="closeSwitcher(false)"
    >
      <i class="icon icon-sm icon-angle-left"></i>
      <span>Back</span>
    </button>

    <div class="search-wrapper">
      <h2 id="search-label" class="sr-only">Select a Program</h2>
      <neo-input-search
        #searchInput
        ariaLabel="Search program"
        autId="program-switcher-search"
        [placeholder]="'Search program'"
        [value]="searchControl.value"
        (searchChanged)="onSearch($event)"
        (keydown)="onSearchKeydown($event)"
      >
      </neo-input-search>
    </div>
  </div>
  } @if (!isMobile) {
  <div class="search-wrapper">
    <h2 id="search-label" class="sr-only">Select a Program</h2>
    <neo-input-search
      #searchInput
      ariaLabel="Search program"
      [placeholder]="'Search program'"
      autId="program-switcher-search"
      [value]="searchControl.value"
      (searchChanged)="onSearch($event)"
      (clearClicked)="clearSearch()"
      (keydown)="onSearchKeydown($event)"
    >
    </neo-input-search>
  </div>
  }
  <div class="programs-list" (keydown)="onListKeydown($event)">
    @for (program of filteredPrograms; track program; let i = $index) {
    <button
      class="program-btn"
      [ngClass]="{ selected: isProgramSelected(program) }"
      (click)="selectProgram(program)"
      (focus)="onItemFocus($event)"
      (blur)="onItemBlur($event)"
      [neoTooltip]="program.name"
      #programItem
      type="button"
      [attr.aut-id]="'program-switcher-program-' + i"
      role="menuitem"
      tabindex="-1"
    >
      <span class="program-info-text">
        <span class="program-info-title">{{ program.name }}</span>
        <span class="program-info-type">{{ program.type }}</span>
      </span>
    </button>
    }
  </div>
</div>
